import AssignProjectManagerOutputPort from "@/presenters/project-manager-presenter";
import ProjectManagerGateway from "@/gateways/project-manager-gateway";
import { StaffId } from "@/entities/ids";

export default interface ProjectManagerInputPort {
  index(): Promise<void>;
  assign(id: StaffId): Promise<void>;
  unassign(id: StaffId): Promise<void>;
  assignAll(ids: StaffId[]): Promise<void>;
  unassignAll(ids: StaffId[]): Promise<void>;
}

export class ProjectManagerInteractor implements ProjectManagerInputPort {
  public constructor(
    private presenter: AssignProjectManagerOutputPort,
    private managers: ProjectManagerGateway
  ) {}

  public async index() {
    this.presenter.info(await this.managers.all());
  }

  public async assign(id: StaffId) {
    try {
      await this.managers.assign(id);
      this.index();
    } catch (e) {
      this.presenter.error(e);
    }
  }

  public async unassign(id: StaffId) {
    try {
      await this.managers.unassign(id);
      this.index();
    } catch (e) {
      this.presenter.error(e);
    }
  }

  public async assignAll(ids: StaffId[]) {
    try {
      await Promise.all(ids.map(id => this.managers.assign(id)));
      this.index();
    } catch (e) {
      this.presenter.error(e);
    }
  }

  public async unassignAll(ids: StaffId[]) {
    try {
      await Promise.all(ids.map(id => this.managers.unassign(id)));
      this.index();
    } catch (e) {
      this.presenter.error(e);
    }
  }
}
